import type { Order, PaymentMethod } from '../../shared/api/types';

export const PAYMENT: Record<PaymentMethod, string> = { cash: 'Efectivo', card: 'Tarjeta', transfer: 'Transferencia', wallet: 'Monedero' };
export const FULFILLMENT: Record<Order['fulfillment'], string> = { pending: 'Recibido', preparing: 'Preparando', ready: 'Listo', delivered: 'Entregado' };
export const NEXT_STEP: Record<Order['fulfillment'], { to: Order['fulfillment']; label: string } | null> = {
  pending: { to: 'preparing', label: 'Preparar' },
  preparing: { to: 'ready', label: 'Marcar listo' },
  ready: { to: 'delivered', label: 'Entregar' },
  delivered: null,
};
